import React from 'react';
import { ExternalLink as ExternalLinkIcon } from 'lucide-react';

// A link to a site outside Optim (ui-architecture.md "External Link"):
// underlined accent-blue text and the external-link icon, opening in a new
// tab — never a chip, which means a record inside Optim. Shows the address
// itself, shortened (no https://www., no trailing slash, "…" once too long),
// so the right profile or site can be checked without clicking; pass label
// instead where the address means nothing to read (e.g. a Google Maps link).
// A bare "acme.com.au" opens as https://acme.com.au.

export function shortUrl(url) {
  return String(url).trim().replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/+$/, '');
}

export function absoluteUrl(url) {
  const u = String(url).trim();
  return /^https?:\/\//i.test(u) ? u : `https://${u}`;
}

function ExternalLink({ href, label, maxWidth = 260 }) {
  const url = absoluteUrl(href);
  const text = label || shortUrl(href);
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      // Inside a click-to-edit field, following the link mustn't also open the editor.
      onClick={(e) => e.stopPropagation()}
      title={`Open ${shortUrl(href)} in a new tab`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4, minWidth: 0, maxWidth, color: '#1976d2', textDecoration: 'underline', textTransform: 'none', letterSpacing: 0 }}
    >
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{text}</span>
      <ExternalLinkIcon size={13} strokeWidth={2} style={{ flexShrink: 0 }} />
    </a>
  );
}

export default ExternalLink;
